import React, { useEffect } from 'react';
import TopContainer from '@src/components/molecules/governance-action-detail/topContainer';
import GovernanceActionMetadata from '@src/components/molecules/governance-action-detail/govActionMetadata';
import type { IGovernanceAction } from '@src/models/types';
import { useLazyProtocolParamsQuery } from '@src/store/config/api';
import { useAppDispatch } from '@src/store/hooks';
import { setProtocolParams } from '@src/store/config/slice';
import type { MetadataValidationResponse } from '@src/models/dtos/metadata';

interface GovernanceActionDetailsLeftContainerProps {
  governanceAction: IGovernanceAction;
  metadataResponse: MetadataValidationResponse | null;
  votesCard: Function;
  isdRepRegistered: boolean;
  isGetDRepDetailsLoading: boolean;
  renderVotedCard: Function;
  votedType: string;
  dRepId: string;
  /** The page header above is server-rendered; skip the card's own title. */
  hasServerHeader?: boolean;
}

const GovernanceActionDetailsLeftContainer: React.FC<
  GovernanceActionDetailsLeftContainerProps
> = ({
  governanceAction,
  metadataResponse,
  votesCard,
  isGetDRepDetailsLoading,
  isdRepRegistered,
  renderVotedCard,
  votedType,
  dRepId,
  hasServerHeader = false,
}) => {
  const { proposal, createdAt } = governanceAction;
  const [fetchEpochParams] = useLazyProtocolParamsQuery();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchEpochParamsData = async () => {
      try {
        const response = await fetchEpochParams(createdAt.epoch).unwrap();
        dispatch(setProtocolParams(response));
      } catch (error) {
        console.error('Failed to fetch epoch params:', error);
      }
    };

    fetchEpochParamsData();
  }, [proposal, createdAt, fetchEpochParams]);

  return (
    <div className="flex w-full flex-col gap-5">
      <TopContainer
        hasServerHeader={hasServerHeader}
        governanceAction={governanceAction}
        metadataResponse={metadataResponse}
        isdRepRegistered={isdRepRegistered}
        isGetDRepDetailsLoading={isGetDRepDetailsLoading}
        renderVotedCard={renderVotedCard}
        votedType={votedType}
        dRepId={dRepId}
      />
      {votesCard('md:hidden')}
      <GovernanceActionMetadata
        governanceAction={governanceAction}
        metadataResponse={metadataResponse}
      />
    </div>
  );
};

export default GovernanceActionDetailsLeftContainer;
